<rt-assistant-list-card [url]="href()" [label]="data().title">
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      [name]="icon()"
      color="colorIconDefault"
      background="colorBgNeutralDefault"
    />
    <span class="label">{{ data().title }}</span>
  </div>
</rt-assistant-list-card>
